import toString from 'lodash/toString'
import { buildDocumentFileUrl, withAttachmentDisposition } from '@klear/upload/file-url'

export function receiptDownloadUrl(traderId: number, documentId: number): string {
  return withAttachmentDisposition(buildDocumentFileUrl(toString(documentId), traderId))
}
